// @flow
import { AsyncRequest, createReducer } from 'angieslist-app-platform';
import { combineReducers } from 'redux';
import cookieUtils from 'angieslist-app-platform/lib/common/utils/cookieUtils';
import advertiseActionKeys from './advertiseActionKeys';
import advertiseUtils from './advertiseUtils';
import type { AsyncState } from '../../../app/types';

const advertiseRequest = createReducer(new AsyncRequest(), {
  [advertiseActionKeys.ADVERTISE_REQUEST_START]:
    (state, action) => AsyncRequest.setStart(state, action.payload),
  [advertiseActionKeys.ADVERTISE_REQUEST_SUCCESS]: (state, action) => {
    action.addSideEffect(store =>
      advertiseUtils.trackAdvertiseRequestSent(true, action.meta, store));
    return AsyncRequest.setSuccess(state, true); // returns 204 so just set to true for success
  },
  [advertiseActionKeys.ADVERTISE_REQUEST_ERROR]: (state, action) => {
    action.addSideEffect(store =>
      advertiseUtils.trackAdvertiseRequestSent(false, action.meta, store));
    return AsyncRequest.setError(state, action.payload);
  },
  [advertiseActionKeys.ADVERTISE_REQUEST_RESET]: state => state.merge({
    isLoading: false,
    request: null,
    response: null,
    error: null,
  }),
});

const advertiseRequestByCategory = createReducer(new AsyncRequest(), {
  [advertiseActionKeys.ADVERTISE_CATEGORY_REQUEST_SUCCESS]: (state, action) => {
    action.addSideEffect((store) => {
      const expireDate = new Date();
      // One week (1 hour in MS * 24 hours * 7 days)
      expireDate.setTime(expireDate.getTime() + (3600000 * 24 * 7));
      cookieUtils.setCookie(`category-advertising-requested-${action.meta.categoryGroupId}`, true, expireDate.toUTCString());
    });
    return state.setIn(['response'], action.meta.categoryGroupId);
  },
  [advertiseActionKeys.ADVERTISE_CATEGORY_REQUEST_ERROR]: (state, action) =>
    state.setIn(['error'], action.meta.categoryGroupId),
  [advertiseActionKeys.ADVERTISE_CATEGORY_REQUEST_START]: (state, action) =>
    state.setIn(['isLoading'], action.meta.categoryGroupId),
});

const contactCountByTopCategory =
  AsyncRequest.createReducer(advertiseActionKeys.ADVERTISE_CONTACT_COUNT);

export type AdvertiseReducerState = {
  advertiseRequest: AsyncState<{}, {}>,
  advertiseRequestByCategory: AsyncState<{}, {}>,
  contactCountByTopCategory: AsyncState<{}, {}>,
};

export default (combineReducers({
  advertiseRequest,
  advertiseRequestByCategory,
  contactCountByTopCategory,
}): any);



// WEBPACK FOOTER //
// ./src/app/common/advertise/advertiseReducer.js